<template>
  <modal :show.sync="show" modalClasses="medium-sized-modal" :hidefooter="true">
    <h3 slot="header" class="mb-0 font-weight-500">Email Notification Template</h3>

    <ValidationObserver v-slot="{ invalid }" ref="observer">
      <b-form @submit.prevent="submit" ref="updateStatusForm">
        <div>
          <!-- Title as Text -->
          <b-row>
            <b-col lg="12">
              <p><strong>Title:</strong> {{ form.notif_temp_title }}</p>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="12">
              <b-form-group label="Trigger Point">
                <b-form-select
                  v-model="form.triggerPoint"
                  :options="emailTriggerPointOptions"
                  disabled
                ></b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
          
          <b-row>
            <b-col lg="12">
              <b-form-group label="Receive Notification">
                <b-form-checkbox
                  v-model="form.receive_notification"
                  switch
                  class="ml-5"
                ></b-form-checkbox>
              </b-form-group>
            </b-col>
          </b-row>
        </div>

        <hr class="my-4" />
        <div class="text-right">
          <base-button
            type="primary"
            v-if="form.notif_temp_id"
            @click="submitUpdate"

          >
            Update
          </base-button>
        </div>
      </b-form>
    </ValidationObserver>
  </modal>
</template>

<script>
import Modal from "@/components/Modal";
import { Select, Option, Checkbox } from 'element-ui'
import { mapState , mapActions} from "pinia";
import {
  notifyFunctionMixin,
  helperFunctionMixin,
  axios,
  services,
  getHeader
} from '@/assets/js/httpImports.js'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import '@/assets/js/formValidations.js'
import mainEventBus from '@/assets/js/mainEventBus.js'
import { useAccessControlStore } from "@/stores/accessControlStore";
import { EMAIL_TRIGGER_POINTS , NOTIFICATION_TRIGGER_POINTS } from "@/assets/js/status.js";
import { useNotificationStore } from '@/stores/notificationStore'
import { useAuthStore } from '@/stores/authStore'

export default {
    props: {
      email_notification_templates: Boolean,
        template_data: {
            type: Object
        },
    },
    mixins:[
        notifyFunctionMixin,
        helperFunctionMixin
    ],
    components: {
        Modal,
        ValidationObserver,
        ValidationProvider,
        [Select.name]: Select,
        [Option.name]: Option,
        [Checkbox.name]: Checkbox,
    },
    computed: {
      ...mapState(useAuthStore, ['auth_user']), 
        show: {
            get() {
                return this.email_notification_templates;
            },
            set(newVal) {
                this.$emit('update:email_notification_templates', newVal);
            },
        },
       
    emailTriggerPointOptions() {
        return Object.keys(EMAIL_TRIGGER_POINTS).map(key => ({
            value: key,
            text: EMAIL_TRIGGER_POINTS[key],
        }));
    },
    notificationTriggerPointOptions() {
        return Object.keys(NOTIFICATION_TRIGGER_POINTS).map(key => ({
            value: key,
            text: NOTIFICATION_TRIGGER_POINTS[key],
        }));
    },
    assignAdvisorOptions() {
      return [
        { value: 1, text: "Yes" },
        { value: 0, text: "No" }
      ];
    }
  },
    data() {
        return {
          form: {
            notif_temp_id: null,
            notif_temp_title: "",
            triggerPoint: "",
            receive_notification: false, // New property for the toggle
          },
          email_notifications: [], 

      }
    },
    async created() {
      const notificationStore = useNotificationStore();
      // await notificationStore.fetchExistingData();

      this.$watch(
      () => this.template_data,
      (newVal) => {
          if (newVal) {
              this.form.notif_temp_id = newVal.notif_temp_id ?? null;
              this.form.notif_temp_title = newVal.notif_temp_title ?? '';
              this.form.triggerPoint = newVal.trigger_point ?? ''; // Correct assignment
              // Only assign if notif_temp_id matches, otherwise set to false
              if (
                this.auth_user &&
                this.auth_user.account_info &&
                this.auth_user.account_info.user_settings &&
                Array.isArray(this.auth_user.account_info.user_settings.email_notifications) // Check if it's an array
              ) {
                const userNotificationSettings = this.auth_user.account_info.user_settings.email_notifications;

                // Find the notification object that matches the current notif_temp_id
                const matchedNotif = userNotificationSettings.find(
                  (notif) => notif.notif_temp_id === newVal.notif_temp_id
                );

                // Check if a matching notification was found
                if (matchedNotif) {
                  // If found, assign the is_enabled value to receive_notification
                  this.form.receive_notification = !!matchedNotif.is_enabled; // Ensure boolean value
                } else {
                  // If no match found, set receive_notification to false
                  this.form.receive_notification = false;
                }
              } else {
                // If user settings are not defined, set receive_notification to false
                this.form.receive_notification = false;
              }
            }
          },
          { immediate: true }
      );
    },
    methods:{
      ...mapActions(useAuthStore,['fetchUserInfo']),
      ...mapActions(useAccessControlStore, ['updateUser']),

      async submitUpdate() 
      {
        // Check if email_notifications array exists and is not empty
        const notifications = Array.isArray(this.auth_user.account_info.user_settings.email_notifications) 
        ? this.auth_user.account_info.user_settings.email_notifications 
        : [];

        // Check if the notification with the same notif_temp_id exists
        const existingNotif = notifications.find(
          (notif) => notif.notif_temp_id === this.form.notif_temp_id
        );


        if (existingNotif) {
          // Update the existing record
          existingNotif.trigger_point = this.form.triggerPoint;
          existingNotif.is_enabled = this.form.receive_notification;
        } else {
          // Insert new record if notif_temp_id is not found
          notifications.push({
            notif_temp_id: this.form.notif_temp_id,
            trigger_point: this.form.triggerPoint,
            is_enabled: this.form.receive_notification,
          });
        }
        // Prepare the data for the API request
        let data = {
          name: this.auth_user.name,
          email: this.auth_user.email,
          role_apps: [
            {
              role_id: this.auth_user.account_info.role_id,
              setting_json: {
                email_notifications: notifications, // Use the modified notifications array
              },
            },
          ],
        };
        await this.updateUser(this.auth_user.id,data);

      // axios.put(services.access_control + 'user/' + this.auth_user.id, data, { headers: getHeader() })
			// 	.then(res => {
			// 		_gNotif.notifySuccess('<b>User:</b> - Successfully Updated.');
          this.$emit('closeEmailNotificationModal', false)
				// })
				// .catch(e => {
				// 	_gNotif.errorFunction(e);
				// });
    } 
  }
}
</script>